import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { changeRows } from '../data/content';
export function ComparisonTable() {
  return <section aria-labelledby="comparacion" className="border-y border-line bg-canvasAlt" data-id="element-35" data-mp="2pnjndcfmz3y8">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-36" data-mp="2umehhaj20exn">
        <Reveal data-id="element-37" data-mp="3ic8v3ub767iy">
          <h2 id="comparacion" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-38" data-mp="3icicwum398dk">
            ¿Qué cambia cuando empezás a volver a ti?
          </h2>
        </Reveal>

        <Reveal delay={0.04} className="mt-6 overflow-x-auto" data-id="element-39" data-mp="38czvaktnhyoo">
          <table className="w-full min-w-[32rem] border-collapse" data-id="element-40" data-mp="3dcvwkcayrc0j">
            <thead data-id="element-41" data-mp="3df8pfki9f6sd">
              <tr className="border-b border-lineStrong" data-id="element-42" data-mp="1wyw1ben2cajm">
                <th className="w-1/2 py-3 pr-4 text-center text-xs font-bold uppercase tracking-[0.16em] text-ink-subtle" data-id="element-43" data-mp="1wxb6dnwu6pl8">
                  Sin Vuelve a Ti™
                </th>
                <th className="w-1/2 py-3 pl-4 text-center text-xs font-bold uppercase tracking-[0.16em] text-accent" data-id="element-44" data-mp="2dygnzew28so3">
                  Con Vuelve a Ti™
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-45" data-mp="2nwec82dx6pgp">
              {changeRows.map(row => <tr key={row.sin} data-id="element-46" data-mp="2ivqopqowgqr8">
                  <td className="py-3 pr-4 text-sm text-ink-subtle" data-id="element-47" data-mp="2iyv0b94p2orx">
                    <span className="flex items-center justify-center gap-2" data-id="element-48" data-mp="2wuqb0roxwtk8">
                      <XIcon size={14} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-49" data-mp="2stmxwcya1bmp" />
                      {row.sin}
                    </span>
                  </td>
                  <td className="py-3 pl-4 text-sm font-semibold text-ink" data-id="element-50" data-mp="3gk0qc4krxcht">
                    <span className="flex items-center justify-center gap-2" data-id="element-51" data-mp="3ghwd2w0zj14v">
                      <CheckIcon size={14} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-52" data-mp="3bn0lfwznufsa" />
                      {row.con}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Reveal>
      </div>
    </section>;
}